import { render, staticRenderFns } from "./customer-loyalty.vue?vue&type=template&id=ff8798b4&scoped=true"
import script from "./customer-loyalty.vue?vue&type=script&lang=js"
export * from "./customer-loyalty.vue?vue&type=script&lang=js"
import style0 from "./customer-loyalty.vue?vue&type=style&index=0&id=ff8798b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8798b4",
  null
  
)

export default component.exports